<template>
  <TopNav></TopNav>
  <h1>Üslü Sayı Hesaplama</h1>
  <fieldset>
    <legend>Üslü Sayı Hesaplama Aracı</legend>
    <label for="a">Sayı: </label> <input type="number" v-model.number="sayi" id="a" step="any" class="blue">
    <br>
    <label for="b">Üs: </label> <input type="number" v-model.number="us" id="b" step="any" class="fuchsia">
    <br><br>
    <span class="blue">{{ sayi }}</span><sup class="fuchsia">{{ us }}</sup> = <span class="green">{{ sonuc() }}</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "UsluSayi",
  data() {
    return {
      sayi: 9,
      us: 3,
    }
  },
  components: {
    TopNav
  },
  methods: {
    sonuc: function () {
      const formatter = new Intl.NumberFormat('tr-TR', {
        maximumFractionDigits: 10
      });
      const sonuc = Math.pow(this.sayi, this.us);
      const sonucNumber = Number(sonuc);
      return formatter.format(sonucNumber);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 110px;
}

.blue {
  color: blue;
}

.green {
  color: green;
}

.fuchsia {
  color: fuchsia;
}

footer section a {
  margin: 20px;
}
</style>
